module.exports = __webpack_public_path__ + "img/icon_map_wxz.514accf8.png";